import { actionTypes, conditionIndicesViewOptions } from '../constants';

export const previousSearchFilter = (searchParams) => {
    return (dispatch) => {
        dispatch({
            type: actionTypes.PREVIOUS_SEARCH_FILTER,
            searchParams
        });
    };
};

export const getHierarchyConditionIndices = (payload, conditionIndicesView) => ({
    type: conditionIndicesView === conditionIndicesViewOptions.HIERARCHY
        ? actionTypes.GET_HIERARCHY_VIEW_REQUEST
        : actionTypes.GET_LIST_VIEW_REQUEST,
    payload,
    conditionIndicesView
});
